import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from '@zurich/common/hooks';
import { InfoCard } from './InfoCard';
export const InfoCardEmpty = ({ title, description, illustration, }) => {
    return (_jsx(InfoCard, { title: title, description: description && _jsx(Trans, { i18nKey: description }), illustration: illustration }));
};
